import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_TerminationLetter = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_TerminationLetter' className='file-pdf-document'>
            <div className='file-template'>

               
                <p>
                    Dear ,<br />
                    Life Solutions South has not heard back from you since the date of our Outreach Letter requesting your
                    communication to our agency as to whether or not you wish to continue services with our agency.

                    Therefore, as of <input type="text" id="txtInputNameValue" name="txtInputNameValue" className='add-only' />

                    , your services at Life Solutions South have been terminated. <br />
                    If you would like to re-enroll in services, please call the Life Solutions South Intake department at <strong>513-574-1500;</strong>
                    or if you need additional assistance, please call:
                    <ul>
                        <li>Hamilton County Crisis line at (513) 558-8888</li>
                        <li>If you are experiencing a medical emergency, please call 911.</li>
                    </ul>
                    <br /> 
                    We wish you and your family the best and hope to hear from you soon. <br /><br />
                    Sincerely, <br /> 
                    <strong>Don Potter MSW, LISW-S, LICDC
                        <br /> Southern Ohio Regional Clinical Director</strong><br />
                    Life Solutions South <br />
                    4342 Harrison Ave, Suite 1 <br />
                    Cincinnati, OH 45211 <br />
                    (Office) 513-574-1500 <br />
                    (Cell) 216-223-8341
                </p>
                <h4>*Should you feel that you would like to file a grievance, please contact our Cleveland office at 216-236-3028</h4>
                <p>
                    <span className='small'>
                        <center>
                            
                        Dayton: 4130 Linden Avenue Suite 245 Dayton, Ohio 45432 <br />
                                Cleveland: 2728 Euclid Avenue, Suite 400 Cleveland, Ohio 44115 <br />
                                Akron: 333 South Main Street, Suite 105 Akron, Ohio 44308 <br />
                        Cincinnati: 4342 Harrison Avenue, Suite 1, Cleveland, Ohio 45211
                        </center>
                        
                    </span>
                    
                    <span className='small'>
                        <center>
                        <a href="www.lifesolutionsouth.com">www.lifesolutionsouth.com</a></center>
                    </span>

                </p> 
            </div>
        </form>

    )
}